import React, { Fragment, useEffect } from "react";
import { BrowserRouter, Route } from "react-router-dom";

// import { loadUser } from "./actions/userActions";

// components
// import Login from "./components/auth/Login";

import NotchNav from "./components/layout/NotchNav";

import DrawCharts from "./components/layout/DrawCharts";

function App() {
  // set global auth header and user, when app renders first
  // useEffect(() => {
  //   console.clear();
  // }, []);

  // COMMENT THIS OUT ONLY WHEN APP IS UNDER MAINTAINENCE
  // return <Maintenance />;

  return (
    <Fragment>
      <BrowserRouter>
        <NotchNav />
        <Route path="/" component={DrawCharts} />
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
